document.addEventListener('DOMContentLoaded', function() {
  const slider = document.querySelector('.slider');
  const arrowLeft = document.querySelector('.arrow-left');
  const arrowRight = document.querySelector('.arrow-right');
  let currentIndex = 0;

  const slides = document.querySelectorAll('.slider-item');
  const totalSlides = slides.length;

  // Move to next slide
  function goToSlide(index) {
    if (index < 0) {
      currentIndex = totalSlides - 1;
    } else if (index >= totalSlides) {
      currentIndex = 0;
    } else {
      currentIndex = index;
    }
    slider.style.transform = 'translateX(' + (-currentIndex * 100) + '%)';
  }

  // Next and previous buttons
  arrowRight.addEventListener('click', function() {
    goToSlide(currentIndex + 1);
  });

  arrowLeft.addEventListener('click', function() {
    goToSlide(currentIndex - 1);
  });

  // Optional: Auto slide every 5 seconds
  setInterval(function() {
    goToSlide(currentIndex + 1);
  }, 5000);
});
